import store from '@/store';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';

const WARNING_MATERIALS = [
  {
    name: 'PML-W100 (25X25)R',
    articleNumber: '0830429',
  },
  {
    name: 'PML-W100 (50X50)R',
    articleNumber: '0830430',
  },
  {
    name: 'PML-W100 (100X100)R',
    articleNumber: '0830431',
  },
  {
    name: 'PML-W200 (25X25)R',
    articleNumber: '0830451',
  },
  {
    name: 'PML-W200 (50X50)R',
    articleNumber: '0830452',
  },
  {
    name: 'PML-W200 (100X100)R',
    articleNumber: '0830453',
  },
  {
    name: 'US-PML-W100 (25X25)',
    articleNumber: '1014125',
  },
  {
    name: 'US-PML-W100 (50X50)',
    articleNumber: '1014126',
  },
  {
    name: 'US-PML-W100 (100X100)',
    articleNumber: '1014127',
  },
  {
    name: 'US-PML-W200 (25X25)',
    articleNumber: '1014131',
  },
  {
    name: 'US-PML-W200 (50X50)',
    articleNumber: '1014132',
  },
  {
    name: 'US-PML-W200 (100X100)',
    articleNumber: '1014133',
  },
];

export default () => {
  const { core: { colorSchema } } = store.getState();
  const matfileTemplate = getBuildedMatfileTemplate();

  return WARNING_MATERIALS.some(item => matfileTemplate?.name.includes(item.name) || `${colorSchema?.article_number || ''}` === item.articleNumber);
};
